import React, { useCallback, useState } from 'react';

import { Button, Gap, Gutter, Text, Title } from '@common/components';
import {
  AuthTemplateCentralizedContainer,
  AuthTemplateHelp,
  AuthTemplateLogo,
  SignInEmailFormRecordType,
} from '@identity/components';
import { useRedirectPath } from '@identity/hooks/use-redirect-path';
import Auth from 'works/legacy/lib/auth';
import { useQueryParam } from 'works/legacy/services/query-params-service';
import { SignInPageActiveAccountsList } from './_sign-in-page-active-accounts-list';
import { SignInPageUserConfirmation } from './_sign-in-page-user-confirmation';

export function SignInPage() {
  const redirectPath = useRedirectPath();
  const newSession = useQueryParam('newSession');
  const [sessionExpired] = useState(!!redirectPath && Auth.signedIn());
  const [worksAuthInfo, setWorksAuthInfo] =
    useState<SignInEmailFormRecordType | null>(null);
  const [lastEmail, setLastEmail] = useState('');
  const [title, setTitle] = useState<string>('');
  const [backAction, setBackAction] = useState<(() => void) | null>(null);

  const handleWorksAuthInfo = useCallback(
    (info: SignInEmailFormRecordType | null) => {
      if (info?.email) setLastEmail(info.email);
      setWorksAuthInfo(info);
    },
    []
  );

  const handleSetBackAction = useCallback(
    (action: (() => void) | null) => setBackAction(() => action),
    []
  );

  return (
    <AuthTemplateCentralizedContainer>
      <div className="sign-in-page">
        <AuthTemplateLogo />

        <Gutter asPadding size="xxl" />

        <Gap size="md" justify="stretch" vertical fullWidth>
          {backAction && (
            <Button kind="link" size="sm" onClick={backAction}>
              Back
            </Button>
          )}

          <Title size="h1" weight="medium">
            {title}
          </Title>

          {!worksAuthInfo && sessionExpired && !newSession && (
            <Text color="coral">
              Your session has expired due to inactivity.
            </Text>
          )}

          {!worksAuthInfo && (
            <SignInPageActiveAccountsList
              initialEmail={lastEmail}
              sessionExpired={sessionExpired}
              newSession={newSession}
              setWorksAuthInfo={handleWorksAuthInfo}
              setTitle={setTitle}
            />
          )}

          {worksAuthInfo && (
            <SignInPageUserConfirmation
              setTitle={setTitle}
              worksAuthInfo={worksAuthInfo}
              onChangeEmail={() => setWorksAuthInfo(null)}
              onBackAction={handleSetBackAction}
            />
          )}

          <AuthTemplateHelp />
        </Gap>
      </div>
    </AuthTemplateCentralizedContainer>
  );
}
